exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-toast-style {\n    background: transparent !important;\n    margin: 0 !important;\n    padding: 0px !important;\n    width: 400px !important;\n}\n\n.default-toast-style .Toastify__toast--default {\n    background: transparent !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n}\n", ""]);

// exports
